import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import { getUserList } from 'actions/users';

import styles from 'styles/index';

import Table from './Table';

const UserBanListPage = ({ isLoaded, getUserList }) => {
    useEffect(() => {
        getUserList({ page: 1 });
    }, [getUserList]);

    return (
        <div id='users-ban' className='container'>
            <CircularProgress
                className={!isLoaded ? '' : 'hidden'}
                style={styles.circularProgress}
            />

            <div className={isLoaded ? '' : 'hidden'}>
                <div className='container'>
                    <h2>
                      Users list
                    </h2>
                </div>

                <Table />
            </div>
        </div>
    );
};

export default connect(
    (state) => {
        return {
            isLogged: state.user.isLogged,
            isLoaded: state.users.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getUserList,
    },
    dispatch),
)(UserBanListPage);



// WEBPACK FOOTER //
// ./app/components/Users/BanList/Page.jsx